import { useQuery } from "@tanstack/react-query";
import Keys from './query.keys'
import api from '@/api'

const getStageListForEvent = (eventId: string) => 
  useQuery(
    Keys.getStageListForEvent(eventId),
    () => api.stage.getStageListForEvent(eventId).then(({ data }) => data),
    {
      enabled: !!eventId,
      staleTime: 60 * 1000 * 60,
      placeholderData: []
    }
  )

export { Keys as StageQueryKeys }

export default {
  getStageListForEvent
}